export default __webpack_public_path__ + "static/media/favorites-chest.4403fb3d.png";